import { formatDate } from '@angular/common';
import { Component, OnInit, Query } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { BlockModel } from 'src/app/core/models/BlockModel';
import { PriorityLevelEnum, PriorityLevelMapping } from 'src/app/core/models/PriorityLevelEnum';
import { QueryCategoryModel } from 'src/app/core/models/QueryCategoryModel';
import { QueryDetailModel } from 'src/app/core/models/QueryDetailModel';
import { QueryModel } from 'src/app/core/models/QueryModel';
import { QuerySubCategoryModel } from 'src/app/core/models/QuerySubCategoryModel';
import { RegisteredUserModel } from 'src/app/core/models/RegisteredUserModel';
import { SubDepartmentModel } from 'src/app/core/models/SubDepartmentModel';
import { User } from 'src/app/core/models/user';
import { BreadcrumbService } from 'src/app/core/services/breadcrumb.service';
import { DbMasterService } from 'src/app/core/services/db-master.service';
import { UserService } from 'src/app/core/services/user.service';

import { NzModalService } from 'ng-zorro-antd/modal';
import { AddAttachmentsComponent } from '../add-attachments/add-attachments.component';
import { CompanyModel } from 'src/app/core/models/CompanyModel';
import { Router } from '@angular/router';
import { NzStatus } from 'ng-zorro-antd/core/types';
import { QueryStatus } from 'src/app/core/models/QueryStatus';
import { ClarificationQueryListService } from '../clarification-query-list.service';


@Component({
  selector: 'app-create-query',
  standalone: false,
  templateUrl: './create-query.component.html',
  styleUrl: './create-query.component.less'
})
export class CreateQueryComponent implements OnInit {
  createQueryForm!: FormGroup;

  showSuccessDiv: boolean = false;
  priorityLevelMapping = PriorityLevelMapping;
  priorityLevels = Object.values(PriorityLevelEnum);

  output: any;
  query: QueryModel = new QueryModel();
  queryDetail: QueryDetailModel = new QueryDetailModel();
  responseModel: QueryModel = new QueryModel();

  blockMaster: BlockModel[] = [];
  departmentMaster: SubDepartmentModel[] = [];
  subDeptMaster: SubDepartmentModel[] = [];
  deptSubDeptMaster: SubDepartmentModel[] = [];
  categoryMaster: QueryCategoryModel[] = [];
  subCatMaster: QuerySubCategoryModel[] = [];
  partnerUserMaster: RegisteredUserModel[] = [];
  selectedCCPartnerUsers = [];


  queryStatus: string = "New";
  requestedDate: Date = new Date();
  currentUser: User = new User();
  requestorDetail: User = new User();
  subjectMaxLength: number = 80;

  files: File[] = []; // Array to hold selected files
  dropdownSettings = {}; // Dropdown settings

  priorities = ['Low', 'Medium', 'High']; // Dropdown values for Priority
  departments = ['HR', 'Finance', 'IT', 'Operations']; // Example departments
  subDepartments = ['Payroll', 'Recruitment', 'Support', 'Development']; // Example sub-departments
  isMasterDataLoaded: boolean = false; // Flag to check if master data is loaded

  constructor(private fb: FormBuilder,
    private dbMasterService: DbMasterService,
    private breadcrumbService: BreadcrumbService,
    private userService: UserService,
    private messageService : NzNotificationService,
    private modalService: NzModalService,
    private router: Router,
    private queryService: ClarificationQueryListService
  ) {
    this.requestorDetail = new User();  
    this.queryDetail.Block_Code = 0;
    this.queryDetail.PriorityLevel_Id = Number(PriorityLevelEnum.Low);
  }

  ngOnInit(): void {
    this.currentUser = this.userService.getCurrentUser();
    if (this.currentUser?.User_Code == null) {
      window.location.href = '/';
    }
    this.queryDetail.Block_Code = 0;

    this.setBreadcrumb();    
    this.initializeLocalVariables();
    this.initializeQueryForm();
  }

  setBreadcrumb() {
    this.breadcrumbService.setBreadcrumbs([
      { label: 'Home', url: '/' },
      { label: 'Clarification Query', url: '/clarification-query' },
      { label: 'Create Query' }
    ]);
  }

  initializeLocalVariables() {
    if (this.currentUser.IsRFCAdmin || this.currentUser.Is_Partner) {
      if (this.currentUser.IsRFCAdmin) {
        this.requestorDetail.Company = new CompanyModel();
        this.requestorDetail.Block = new BlockModel();
      }
      else{
        this.requestorDetail = this.currentUser;
        if(this.requestorDetail.Block?.Block_Code != 3)
        this.queryDetail.Block_Code = this.requestorDetail.Block?.Block_Code??0 ;
      }

      this.query = new QueryModel();
      this.query.Subject='';
      //this.query.QueryDetail = this.queryDetail;
     
      this.queryDetail.Department_Code = "";
      this.queryDetail.PriorityLevel_Id = Number(PriorityLevelEnum.Low);
      this.queryDetail.CCEmails = "";
      this.queryDetail.Sub_Dept_Code = "";
      this.requestedDate = new Date();
    }
    else {
      this.redirectToHome();
    }
  }
  redirectToHome() {
    this.router.navigate(['/home']);
  }

  initializeQueryForm(): void {
    const currentDate = formatDate(new Date(), 'dd-MMM-yyyy', 'en-US');
    // Initialize the reactive form
    this.createQueryForm = this.fb.group({
      requestStatus: [{ value: 'New', disabled: true }],
      dateOfRequest: [{ value: currentDate, disabled: true }], // Current date, readonly
      subject: ['', Validators.required],
      priority: [PriorityLevelEnum.Low, Validators.required],
      ccEmails: ['', this.semiColonSeparatedEmailsValidator],
      confidential: [false],
      department: [''],
      subDepartment: [''],
      cc: [[]], // Multi-select dropdown
      partnerComments: ['', Validators.required], // Mandatory field      
      requestorName: [
        {
          value: this.currentUser.IsRFCAdmin ? this.currentUser : this.currentUser.User_Name,
          disabled: !this.currentUser.IsRFCAdmin
        }
      ],
      requestorEmail: [{ value: this.requestorDetail.Email, disabled: true }],
      company: [{ value: this.requestorDetail.Company?.Company_Name, disabled: true }],
      //block: [{ value: this.currentUser.Block?.Block_Name, disabled: true }]
      block: [
        {
          value: this.requestorDetail.Block?.Block_Code != 3
            ? this.requestorDetail.Block?.Block_Name
            : null,
          disabled: this.currentUser.Block?.Block_Code != 3
        },
        Validators.required
      ]
    });

    this.createQueryForm.patchValue({
      requestStatus: 'New'
    });

    this.initialiseMasterData();
  }
  logReasonForInvalidForm() {
    
    Object.keys(this.createQueryForm.controls).forEach(key => {
      const controlErrors = this.createQueryForm.get(key)?.errors;
      if (controlErrors) {
        console.log(`Field: ${key}, Errors:`, controlErrors);
      }
    });
  }
  showMessage(): void {
    this.messageService.create('success', 'Success', 'Query created successfully');
  }
  showDeactivateModal(): void {  
      this.modalService.confirm({
        nzTitle: 'Confirm !',
        nzContent: 'Are you sure, you want to <b>Submit the Query?</b>',
        nzOkText: 'Yes',
        nzWidth: '500px',
        nzOkType: 'primary',
        nzOkDanger: true,
        nzClosable: false,
        nzAutofocus: null,
        nzOnOk: () => this.onSubmit(),
        nzCancelText: 'No',
        nzOnCancel: () => console.log('Cancel')
      });
    }
  // Submit handler
  onSubmit(): void {    
    if (this.createQueryForm.valid) {
      //console.log('Form Submitted:', this.createQueryForm.getRawValue());
      this.createQueryObjectFromCreateQueryForm();         
      if (this.currentUser.IsRFCAdmin) {
        this.queryService.submitQueryByRFCAdmin(this.query, this.files).subscribe((response: any) => {
          
          this.responseModel = response.output;
          
          this.showSuccessDiv = true;
        }, error => {
          this.messageService.error("Error occurred while submitting the request", 'Notification');
        });
      }
      else {
        this.queryService.submitQuery(this.query, this.files).subscribe((response: any) => {         
          this.responseModel = response.output;
          this.showSuccessDiv = true;
          
        }, error => {
          this.messageService.error("Error occurred while submitting the request", 'Notification');
          console.log(error);
        });
      }
    } else {
      
    }
  }
  createQueryObjectFromCreateQueryForm(): QueryModel {
    this.query = new QueryModel();
    
    this.query.Subject = this.createQueryForm.get('subject')?.value;
    this.query.Created_By = this.currentUser.User_Code??0;    
    this.query.Company_Code = this.requestorDetail.Company?.Company_Code??0;
    this.query.Requestor_Code = this.requestorDetail.User_Code??0;
    this.query.QueryStatusEnum = QueryStatus.New;

    this.query.RequestorDetail= this.requestorDetail;

    this.queryDetail = new QueryDetailModel();
    this.queryDetail.Block_Code = this.requestorDetail.Block?.Block_Code == 3 ? this.createQueryForm.get('block')?.value : this.requestorDetail.Block?.Block_Code;
    this.queryDetail.Department_Code = this.createQueryForm.get('department')?.value;
    this.queryDetail.Sub_Dept_Code = this.createQueryForm.get('subDepartment')?.value;
    this.queryDetail.CCEmails = this.createQueryForm.get('ccEmails')?.value;
    this.queryDetail.Is_Confidential = this.createQueryForm.get('confidential')?.value;
    this.queryDetail.PriorityLevel_Id = Number(this.createQueryForm.get('priority')?.value);
    this.queryDetail.Partner_Comment = this.createQueryForm.get('partnerComments')?.value;
    this.queryDetail.CCUsers = this.createQueryForm.get('cc')?.value ?? [];
    this.queryDetail.Modified_By = (this.currentUser.User_Code??0).toString();
    this.queryDetail.PriorityLevel = 'Low';
    this.query.QueryDetail = this.queryDetail;
    
    
    return this.query;

  }

  initialiseMasterData() {
    this.isMasterDataLoaded = false; // Set the flag to false initially
    this.dbMasterService.getMasterDetails(true).subscribe({
      next: (response) => {
        
        this.output = response.output;
        this.blockMaster = this.output.Block as [];

        this.categoryMaster = this.output.Category as [];
        this.subCatMaster = this.output.SubCategory as [];

        this.departmentMaster = this.output.Department.filter((dept: { Active: any; }) => dept.Active) as [];
        this.subDeptMaster = this.output.SubDepartment.filter((subDept: { Active: any; }) => subDept.Active) as [];
        this.partnerUserMaster = this.output.PartnerUsers.filter((user: { Active: any; }) => user.Active) as [];
        this.deptSubDeptMaster = [];
        this.setRequestorDefaultAsCurrentUser();
        this.isMasterDataLoaded = true; // Set the flag to true after loading data
        // You can add more assignments here based on the data structure returned by the service
      },
      error: (err) => {
        console.error('Error fetching master details:', err);
      }
    });
  }
  get loadingText(): string {
    return this.isMasterDataLoaded ? 'Choose' : 'Loading... please wait'; // Change the text based on the loading state
  }
  onDepartmentChange(department_Code: string) {
      this.deptSubDeptMaster = [];
      this.queryDetail.Sub_Dept_Code = "";
  
      // Clear the subDepartment field in the form
      this.createQueryForm.patchValue({
          subDepartment: ''
      });
  
      this.deptSubDeptMaster = this.subDeptMaster.filter(item => item.Department_Code == department_Code);      
  }

  // Custom validator for semicolon-separated email addresses
  semiColonSeparatedEmailsValidator(control: AbstractControl): ValidationErrors | null {
    const emailList = control.value?.split(';').map((email: string) => email.trim());
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex

    if (!control.value) {
      return null; // No value, no validation error
    }

    for (const email of emailList) {
      if (email && !emailRegex.test(email)) {
        return { invalidEmail: true }; // Return error if any email is invalid
      }
    }

    return null; // All emails are valid
  }

  // Handle requestor change
  onRequestorChange(selectedUser: RegisteredUserModel): void {
    if (selectedUser) {
      this.requestorDetail = selectedUser;
      this.createQueryForm.patchValue({
        requestorEmail: this.requestorDetail.Email,
        company: this.requestorDetail.Company?.Company_Name,
        block: this.requestorDetail.Block?.Block_Code != 3 ? this.requestorDetail.Block?.Block_Name : this.requestorDetail.Block?.Block_Code        
      });
      if (this.requestorDetail.Block?.Block_Code == 3) {
        this.createQueryForm.get('block')?.setValidators(Validators.required);
        
      } else {
        this.createQueryForm.get('block')?.clearValidators();
        
      }
      this.createQueryForm.get('block')?.updateValueAndValidity();
    }
  }
  setRequestorDefaultAsCurrentUser(): void {
    // If the current user is an admin, set the default value of requestorName to the current user object
    if (this.currentUser.IsRFCAdmin) {
      const currentUserInPartnerList = this.partnerUserMaster.find(
        (user) => user.User_Code === this.currentUser.User_Code
      );

      if (currentUserInPartnerList) {
        this.createQueryForm.patchValue({
          requestorName: currentUserInPartnerList
        });
      }
    }    
  }
  
  openFileUploadModal(): void {
    // Implement your logic to open the file upload modal here
    
    const modalRef = this.modalService.create({
      nzTitle: 'Add Attachments',
      nzClosable: true,
      nzWidth: '60%',
      nzFooter: null,
      nzAutofocus: null,
      nzContent: AddAttachmentsComponent,
      nzData: {
        uploadedFiles: this.files,
        alreadyUploadFileCount: this.files.length,
      },
    });
  
    // Listen to the onFilesUploadClicked event from the add-attachments component
    // and update the files array in the current component
    const instance = modalRef.getContentComponent();
    if (instance) {
      instance.onFilesUploadClicked.subscribe((uploadedFiles: File[]) => {
        
        this.files = []; // Clear the existing files array before adding new files
        this.files = [... uploadedFiles] ; // Update the files array with the uploaded files 
        
      });
    }   
  }
  public getNzStatusColor(control: string): NzStatus {
      const formControl = this.createQueryForm.get(control);
      if (formControl?.touched && formControl.invalid) {
        return 'error';
      }
      return '';
    }
}
